import React, { useState } from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import TabPanel from "../../elements/tab/materialTabPanel";
import ProjectsContainer from "./projects/ProjectsContainer";
import BalancesContainer from "./balances/BalancesContainer";
import FeeContainer from "./fee/FeeContainer";
import ClientConnectionsContainer from "./connections/ClientConnectionsContainer";
import queryString from "query-string";
import { useHistory } from "react-router-dom";
import PaymentsContainer from "./payments/PaymentsContainer";
import PayoutsContainer from "./payouts/PayoutsContainer";
import RatesContainer from "./rates/RatesContainer";
import RangeFeeContainer from "./rangeFee/RangeFeeContainer";
import ProfitContainer from "./profit/ProfitContainer";
import WalletsContainer from "./wallets/WalletsContainer";
import { useTranslation } from "react-i18next";

import { StyledContentWrapper } from "../../styles/styledMain";
import { StyledTabsBody, StyledTabsHead } from "../../styles/styledTabs";
import WalletWhitelistContainer from "./walletWhitelist/WalletWhitelistContainer";
import ReservedBalanceHistoryContainer from "./reservedBalanceHistory/ReservedBalanceHistoryContainer";

const DEFAULT_TAB = "project";

const ClientTabsContainer = ({ match }) => {
  const { t } = useTranslation("clientsPage");
  const history = useHistory();
  let queryParams = queryString.parse(history.location.search);

    const urlForTabs = () => {
      if (!queryParams.currentTab) {
        return 0;
      }

      switch (queryParams.currentTab) {
        case "project": {
          return 0;
        }
        case "balances": {
          return 1;
        }
        case "fee": {
          return 2;
        }
        case "rangeFee": {
          return 3;
        }
        case "rates": {
          return 4;
        }
        case "connections": {
          return 5;
        }
        case "payments": {
          return 6;
        }
        case "payouts": {
          return 7;
        }
        case "profits": {
          return 8;
        }
        case "wallets": {
          return 9;
        }
        case "reservedBalance": {
          return 10;
        }
        case "walletWhitelist": {
          return 11;
        }
      }
    };

    const tabValue = urlForTabs();

    const handleChange = (event, newValue) => {
      if (queryParams.currentTab !== newValue) {
        history.push("?currentTab=" + newValue);
      }
    };

    return (
      <StyledContentWrapper height="auto">
        <StyledTabsHead
          className="tab-head"
          orientation="horizontal"
        >
          <Tabs
            value={queryParams?.currentTab ?? DEFAULT_TAB}
            indicatorColor="secondary"
            onChange={handleChange}
            orientation="horizontal"
            className="tab-head-buttons"
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label={t("details.tabs.project")} value="project" />
            <Tab label={t("details.tabs.balances")} value="balances" />
            <Tab label={t("details.tabs.fee")} value="fee" />
            <Tab label={t("details.tabs.rangeFee")} value="rangeFee" />
            <Tab label={t("details.tabs.rates")} value="rates" />
            <Tab label={t("details.tabs.services")} value="connections" />
            <Tab label={t("details.tabs.payments")} value="payments" />
            <Tab label={t("details.tabs.payouts")} value="payouts" />
            <Tab label={t("details.tabs.profits")} value="profits" />
            <Tab label={t("details.tabs.wallets")} value="wallets" />
            <Tab label={t("details.tabs.reservedBalance")} value="reservedBalance" />
            <Tab label={t("details.tabs.walletWhitelist")} value="walletWhitelist" />
          </Tabs>
        </StyledTabsHead>
        <StyledTabsBody className="tab-body">
          <TabPanel
            value={tabValue}
            index={0}
          >
            <ProjectsContainer match={match} />
          </TabPanel>
          <TabPanel
            value={tabValue}
            index={1}
          >
            <BalancesContainer match={match} />
          </TabPanel>
          <TabPanel
            value={tabValue}
            index={2}
          >
            <FeeContainer match={match} />
          </TabPanel>
          <TabPanel
            value={tabValue}
            index={3}
          >
            <RangeFeeContainer match={match} />
          </TabPanel>
          <TabPanel
            value={tabValue}
            index={4}
          >
            <RatesContainer match={match} />
          </TabPanel>
          <TabPanel
            value={tabValue}
            index={5}
          >
            <ClientConnectionsContainer match={match} />
          </TabPanel>
          <TabPanel
            value={tabValue}
            index={6}
          >
            <PaymentsContainer match={match} />
          </TabPanel>
          <TabPanel
            value={tabValue}
            index={7}
          >
            <PayoutsContainer match={match} />
          </TabPanel>
          <TabPanel
            value={tabValue}
            index={8}
          >
            <ProfitContainer match={match} />
          </TabPanel>
          <TabPanel
            value={tabValue}
            index={9}
          >
            <WalletsContainer match={match} />
          </TabPanel>
          <TabPanel
            value={tabValue}
            index={10}
          >
            <ReservedBalanceHistoryContainer match={match} />
          </TabPanel>
          <TabPanel
            value={tabValue}
            index={11}
          >
            <WalletWhitelistContainer match={match} />
          </TabPanel>
        </StyledTabsBody>
      </StyledContentWrapper>
    );
  }
;

export default ClientTabsContainer;